module.exports = "<div #search class=\"search-box-placer\" *ngIf=\"showSearch\">\n    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n    <input id=\"search\" class=\"search-box\" type=\"text\" placeholder=\"Zoom to location\">\n</div>\n<div #map [ngClass]=\"{'full': !streetViewEnabled(), 'half': streetViewEnabled()}\" id=\"imgMaps\">\n\n</div>\n<div #streetview [ngClass]=\"{'closed': !streetViewEnabled(), 'half': streetViewEnabled()}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/maps/maps.component.html
// module id = 1427
// module chunks = 0